import BaseUISelectedProductMultiParcelView from 'xui/modules/order/BaseUISelectedProductMultiParcelView'

export default class SelectedProductMultiParcelView extends BaseUISelectedProductMultiParcelView {
  // static displayName = 'AddCoverSheetNote'
  static navigationOptions = {
    header: null,
  }
}
